// extracted by mini-css-extract-plugin
var _1 = "qXffekeUzrVk4R7ctahW";
var _2 = "bD4jumo4bnEXxuRUpPpW";
export { _1 as "label", _2 as "root" }
